import React from 'react'
import Template from '../components/core/Auth/Template'

const Login = () => {
  return (
    <div>
        <Template text='Welcome Back' formType='login'/>
    </div>
  )
}

export default Login